<template>
  <div>
    <!-- Report Form -->
    <div class="bg-grey-blue p-3 rounded">
      <FormulateForm v-model="formValues"
                     :errors="formErrors">
        <ifac-report-form :report="report"
                          :can-update="report.can.update"
                          :schema="formSchema"/>
      </FormulateForm>
    </div>

    <!-- Actions Buttons -->
    <div class="row submit-buttons">
      <div class="col text-right right-col p-0">
        <button
          :disabled="report.can.update === false"
          type="submit"
          class="btn btn-secondary"
          @click="mx_update(report)"
        >
          Save
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          :disabled="report.can.submit === false"
          @click="mx_submit(report)"
        >
          <span v-if="report.is_submitted">Submitted</span>
          <span v-else>Submit report</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import reportsMixin from '@/mixins/awards/reports.mixin';
import { IfacReportForm } from '@ifac/ui';

export default {
  name: 'ReportForm',
  mixins: [reportsMixin],
  components: {
    IfacReportForm,
  },
  props: {
    report: {
      type: Object,
    },
  },
  async created() {
    this.formSchema = this.report.form_schema;
    this.formValues = this.report.form_values;
  },
  data() {
    return {
      formSchema: [],
      formValues: {},
      formErrors: {},
    };
  },
};
</script>
